// jv.log4javascript.js
if (window.angular !== undefined) {
    angular.module('jv.log4javascript', [])
        .config([
        '$provide',
        function($provide) {
            $provide.decorator('$log', [
                '$delegate',
                '$window',
                function($delegate, $window) {
                    var _info = $delegate.info;
                    var _error = $delegate.error;
                    var _log = $delegate.log;
                    var _warn = $delegate.warn;
                    var _debug = $delegate.debug;
                    var _context = "";
                    if ($window.jvUrls.currentContext) {
                        _context = "App: " + $window.jvUrls.currentContext.replace(/\//g,'');
                    }
                    var msgToBeSent;
                    //If we need to display the logs on console as well. Enable.JS.Log.Console should be set to true in DB. 
                    var showJSLogConsole = $window.enableJSLogConsole;

                    var ajaxUrl = $window.jvUrls.admin + "/action/sendLogs";

                    var log = log4javascript.getLogger();
                    var ajaxAppender = new log4javascript.AjaxAppender(ajaxUrl);

                    //Dumb Log4javascript threw alerts for any errors. Dug through their documents and found this!
                    log4javascript.logLog.setQuietMode(true);

                    //Where should this value come from? DB?
                    //ajaxAppender.setThreshold(log4javascript.Level.ALL);
                    log.addAppender(ajaxAppender);

                    $delegate.info = function(msg) {
                        if (showJSLogConsole) {
                            _info(msg);
                        }
                        log.info(_context, JSON.stringify(msg));
                    };

                    $delegate.error = function(msg) {
                        if (angular.isDefined(msg) && angular.isDefined(msg.stack)) {
                            msgToBeSent = msg.stack;
                        } else {
                            msgToBeSent = JSON.stringify(msg);
                        }
                        if (showJSLogConsole) {
                            _error(msg);
                        }
                        log.error(_context, msgToBeSent);
                    };

                    $delegate.log = function(msg) {
                        if (showJSLogConsole) {
                            _log(msg);
                        }
                        log.debug(_context, JSON.stringify(msg));
                    };

                    $delegate.warn = function(msg) {
                        if (showJSLogConsole) {
                            _warn(msg);
                        }
                        log.warn(_context, JSON.stringify(msg));
                    };

                    $delegate.debug = function(msg) {
                        if (showJSLogConsole) {
                            _debug(msg);
                        }
                        log.debug(_context, JSON.stringify(msg));
                    };

                    return $delegate;
                }
            ]);
        }
    ]);
}
